import { createSelector } from '@reduxjs/toolkit';

import { getFilterLocation } from '../filters/getFilterLocation';

import { locationsListSelector } from './locationsListSelector';

export const currentLocationByFiltersSelector = createSelector(
  locationsListSelector,
  getFilterLocation,
  (list, location) => list.find(item => item.locationId === location) ?? list[0],
);
